// extracted by mini-css-extract-plugin
export default {"errorImg":"NotFoundPage_errorImg__fySUy"};